export const toEventFormat = (_data) => {
  return {
    id: _data?.eventId ?? _data?.EventId,
    name: _data?.eventName ?? _data?.EventName,
    location: _data?.location ?? _data?.Location,
    image: changeToSecure(_data?.imagepath ?? _data?.Image),
    category: _data?.categoryName ?? _data?.CategoryName,
    rating: _data?.ratings ?? _data?.Ratings,
    isTrending: _data?.IsTrending,
    timeId: _data?.timeId ?? _data.TimeId,
    startDate: _data?.startDate ?? _data?.StartDate,
    isVirtual: _data?.IsVirtual,
    images: _data?.photos ?? _data?.ImageUrls ?? null,
    distance: _data?.nearMe ?? _data?.DistanceMile,
    startTime: _data?.startTime ?? _data?.StartTime,
    isNew: _data?.isNewEvent ?? _data?.IsNewEvent,
    advertisment: _data?.Advertisement ?? null,
    callToBook: _data?.CallToBook || "",
  };
};

export const toAdFormat = (_data) => {
  return {
    name: _data?.eventName ?? _data.Name,
    image: _data?.imagepath ?? _data.ImagePath,
    url: _data?.ticketUrl ?? _data?.Url,
  };
};

const changeToSecure = (_url) => {
  if (_url) return _url.replace("http://", "https://");

  return "";
};
